import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import { hashHistory } from 'react-router';
import { authContext } from '../AzureAd';

import '../css/image-gallery.css';
import '../css/main.css';

import watermark from 'watermarkjs';
import { text } from 'watermarkjs';

export default class PhotographicComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            videoDevices: [],
            currentDeviceIndex: 0
        };
        this.videoRef = null;
        this.canvasRef = null;
        this.stream = null;  // 保存 stream 的引用
    }

    componentWillMount() {
        this.props.pop();
        if (this.props.previousPage == '/refineCards') {
        } else {
            this.props.findPhotos(this.props.view.get('card'),
                this.props.request.get('category'));
        }
    }

    componentDidMount() {
        // 首次加載時請求訪問 Webcam
        navigator.mediaDevices.getUserMedia({
            video: {
                width: { ideal: 2560 },
                height: { ideal: 1440 }
            }
        })
            .then(stream => {
                // 訪問 Webcam 成功後，列舉所有設備
                this.stream = stream;
                return navigator.mediaDevices.enumerateDevices();
            })
            .then(devices => {
                const videoInputDevices = devices.filter(device => device.kind === 'videoinput');
                this.setState({ videoDevices: videoInputDevices });
                if (videoInputDevices.length > 0) {
                    this.setState({ currentDeviceIndex: 0 });
                    this.updateVideoStream(0);
                }
            })
            .catch(error => {
                console.error('Error accessing media devices.', error);
            });
    }

    updateVideoStream(index) {
        const device = this.state.videoDevices[index];
        const constraints = {
            video: {
                deviceId: device.deviceId ? { exact: device.deviceId } : undefined,
                width: { ideal: 2560 },
                height: { ideal: 1440 }
            }
        };

        navigator.mediaDevices.getUserMedia(constraints)
            .then(stream => {
                this.stream = stream;
                if (this.videoRef) {
                    this.videoRef.srcObject = stream;
                }
            })
            .catch(error => {
                if (error.name === 'OverconstrainedError') {
                    console.error(`OverconstrainedError: The constraints cannot be satisfied by the available devices.`, error);
                } else if (error.name === 'NotAllowedError') {
                    console.error(`NotAllowedError: Permissions have not been granted to use media devices.`, error);
                } else {
                    console.error(`Error accessing media devices.`, error);
                }
            });
    }

    setVideoRef = element => {
        this.videoRef = element;
    };

    setCanvasRef = element => {
        this.canvasRef = element;
    };

    componentWillUnmount() {
        this.props.cleanAlert();
        this.props.changeIsLoadingPage(false);
        this.cam_reset();
    }

    handleDeviceChange = (index) => {
        this.setState({ currentDeviceIndex: index }, () => {
            this.updateVideoStream(index);
        });
    };

    cam_take_snapshot() {
        const videoElement = this.videoRef;
        const canvas = this.canvasRef;
        if (!canvas || !videoElement) {
            console.error('Canvas or video element is not available');
            return;
        }
        const context = canvas.getContext('2d');
        context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/png');
        this.watermarking(dataUrl);
        if (dataUrl) {
            this.props.queue();
        }
    }

    watermarking(data_uri) {
        let cardCode = this.props.view.get('card').code;
        watermark([data_uri])
            .image(text.lowerRight(cardCode, '175px Josefin Slab', '#fff', 0.5))
            .then(function (img) {

                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                canvas.getContext("2d").drawImage(img, 0, 0);

                var jpeg = new Image();
                jpeg.src = canvas.toDataURL("image/jpeg");
                jpeg.id = "kkQueue";
                jpeg.className = "gallery-target";
                let kkQueue = document.getElementById('kkQueue');
                document.getElementById('results').replaceChild(jpeg, kkQueue);
            });
    }

    discardPhoto() {
        if (confirm("確定移除暫存檔")) {
            this.discardPhotoSilently();
        }
    }

    discardPhotoSilently() {
        document.getElementById('results').innerHTML = '<span id="kkQueue" ></span>';
        this.props.pop();
    }

    uploadPhoto() {
        let img = document.getElementById('kkQueue');

        let ignoreCardChecking = false;
        if (this.props.previousPage == '/refineCards') {
            ignoreCardChecking = true;
        }

        this.props.changeIsLoadingPage(true);
        this.props.uploadPhoto(img.src,
            this.props.view.get('card'),
            this.props.request.get('category'),
            authContext.getCachedUser().userName,
            ignoreCardChecking
        );

        this.discardPhotoSilently();
    }

    expand() {
        this.props.expandContent();
    }

    cam_reset() {
        if (this.stream) {
            this.stream.getTracks().forEach(track => {
                track.stop();
            });
            this.stream = null;
            if (this.videoRef) {
                this.videoRef.srcObject = null;
            }
        }
    }

    previousPage() {
        this.props.expandContent();
        if (this.props.previousPage == '/refineCards') {
            hashHistory.push("/refineCards");
        } else {
            hashHistory.push("/maintenanceCard");
        }
        this.cam_reset();
        this.props.pop();
    }

    isQueue() {
        return this.props.request.get('queuing');
    }

    viewPhotos() {
        this.cam_reset();
        hashHistory.push("/photoGallery");
    }

    showNote() {
        if (this.props.previousView.get('caseModel') && this.props.previousView.get('caseModel').note) {
            return <span>{this.props.previousView.get('caseModel').note}</span>;
        }
        return '';
    }

    render() {

        let menuToggle = (show) => {
            if (show) {
                return 'menu-hide.svg';
            } else {
                return 'menu-show.svg';
            }
        }

        let headerImage = (category) => {
            if (category === 0) {
                return "shirt.svg";
            } else
                if (category === 1) {
                    return "shorts.svg";
                }
            return 'kk25.jpg';
        }

        let photoSize = 0;
        if (this.props.view.get('photos').length) {
            photoSize = this.props.view.get('photos').length;
        }

        let alertDiv = null;
        if (this.props.alert.get('style') === 'warning' && this.props.alert.get('message')) {
            alertDiv = (
                <Alert bsStyle={this.props.alert.get('style')} onDismiss={this.props.cleanAlert}>
                    {this.props.alert.get('message')}
                </Alert>
            );
        }

        let pageOpacity = (this.props.isLoadingPage) ? 0.2 : 1;

        return (
            <div style={{ opacity: pageOpacity }}><span hidden> PhotographicComponent  </span>
                <div className="snapshot">
                    <Button onClick={(e) => { this.cam_take_snapshot(); }} disabled={this.isQueue()} >
                        <img title="拍照" alt='take photos' src='camera.svg' height="45" width="45" />
                    </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button onClick={(e) => { this.uploadPhoto(); }} disabled={!this.isQueue()} >
                        <img title="上傳" alt='上傳' src='upload.svg' height="45" width="48" />
                    </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button onClick={(e) => { this.discardPhoto(); }} disabled={!this.isQueue()}  >
                        <img title='放棄' alt='放棄' src='cancel.png' height="45" width="45" />
                    </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="notify-item">
                        <span className="notify-badge">{photoSize}</span>
                        <Button onClick={(e) => { this.viewPhotos(); }} >
                            <img title="photos" alt='photos' src='gallery.svg' height="45" width="48" />
                        </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </div>
                <h5 style={{ color: '#5371B6' }}>
                    <a alt="hide or show menus" onClick={(event) => {
                        this.expand();
                    }}><img src={menuToggle(this.props.menu.get('show'))} height="10" width="15" title="hide or show menus" alt="hide or show menus icon" />
                    </a>
                    <img alt='shorts' src={headerImage(this.props.request.get('category'))} height="30" width="30" />
                    <span className='highlight-B'>{this.props.view.get('card').code}</span> &gt;&gt;
                    清點作業管理 &gt;&gt;
                    洗前清點 &gt;&gt;
                    洗前拍照 &gt;&gt;&nbsp;
                    {this.props.previousView.get('caseModel').orderId}&nbsp;-&nbsp;{this.showNote()}&nbsp;
                    <a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                </h5>
                <br />
                <span style={{ fontSize: '1.8rem' }}>即時影像</span>&nbsp;&nbsp;&nbsp;&nbsp;
                {this.state.videoDevices && this.state.videoDevices.length > 1 && this.state.videoDevices.map((device, index) => (
                    <span>
                        <Button bsSize='large' key={device.deviceId} onClick={() => this.handleDeviceChange(index)}>
                            {index + 1}
                        </Button>&nbsp;&nbsp;
                    </span>
                ))}
                {alertDiv}
                <div id="results" >
                    <span id="kkQueue" ></span>
                </div>
                <div style={{ width: 1298, height: 738 }} className='gallery-max' onClick={(e) => { this.cam_take_snapshot(); }}>
                    <video
                        ref={this.setVideoRef}
                        autoPlay
                        width={1280}
                        height={720}
                    />
                    <canvas ref={this.setCanvasRef} width="1280" height="720" style={{ display: 'none' }}></canvas>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PhotographicComponent.jsx